

























import { Component, Prop, Vue } from 'vue-property-decorator'
import { Service, TeamMember } from '@/models'
import { Utils } from '@/utils'

@Component
export default class ProductServicesList extends Vue {
  @Prop({ required: true, type: Array }) readonly services: Service[]
  @Prop({ default: false, type: Boolean }) readonly activeFilter: boolean

  private utils = Utils

  private filterByTeam(team: TeamMember) {
    this.$emit('filterByTeam', team)
  }
}
